import { render } from "./details.vue?vue&type=template&id=4fbacdc2&ts=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"

import "./details.vue?vue&type=style&index=0&id=4fbacdc2&lang=css"

import exportComponent from "D:\\01.Works\\BoonRock\\114.X1Studio\\001.PMS\\31.Dev\\99_source\\crm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__